// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./static/css/icon.css
// module id = ympj
// module chunks = 111